var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"background-color":"#eee","overflow-y":"auto"},style:(_vm.th)},[_c('div',{staticStyle:{"padding":"10px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }